module.exports = __webpack_public_path__ + "static/media/logo404.f2f90e67.svg";